import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { CartaoAtualType, ListaFaturaType } from "models/cartao";
import { createSlice } from "@reduxjs/toolkit";
import {
  resetLoading,
  setLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { getListaFaturas } from "services/http/cliente-service";
import { RouteNames } from "routes/routes";

type CartaoState = {
  cartao: CartaoAtualType;
  telaBloqueio: boolean;
};

const initialState: CartaoState = {
  cartao: {
    numeroCartao: "",
  },
  telaBloqueio: true,
};

type SearchInvoicesPayload = {
  cpf: string;
  tokenCartao: string;
  numeroCartao: string;
};

const handleCartaoCliente = (
  state: CartaoState,
  action: PayloadAction<string>
) => {
  if (state.cartao) {
    state.cartao.numeroCartao = action.payload;
  }
};

const handleSetTelaBloqueio = (
  state: CartaoState,
  action: PayloadAction<boolean>
) => {
  state.telaBloqueio = action.payload;
};

export const fetchListFaturaCliente = createAsyncThunk(
  `cartao/faturaCartao`,
  async (props: SearchInvoicesPayload, { dispatch }) => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando dados da tua fatura aguarde..."));
    const response = (await getListaFaturas(
      props.cpf,
      props.numeroCartao,
      props.tokenCartao
    )
      .then((res) => res.data)
      .catch((error) => {
        dispatch(resetLoading());
        const { mensagem } = error.response.data;
        showMessage("warning", "Atenção!", mensagem, {
          timer: 7000,
          willClose: () => {
            window.location.href = RouteNames.ATENDIMENTO_HOME;
          },
        });
      })) as ListaFaturaType;
    dispatch(resetLoading());
    return response;
  }
);

export const cartaoSlices = createSlice({
  name: "cartao",
  initialState: { ...initialState },
  reducers: {
    setCartao: handleCartaoCliente,
    cleanStateCartao: (state) => initialState,
    setTelaBloqueio: handleSetTelaBloqueio,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchListFaturaCliente.fulfilled, (state, action) => {
      state.cartao.fatura = action.payload;
    });
  },
});

export const { setCartao, cleanStateCartao, setTelaBloqueio } =
  cartaoSlices.actions;

export default cartaoSlices.reducer;
